<template>
  <div class="rating-widget">
    <input :name="name" type="hidden" :value="local" />
    <icon
      v-for="i in range"
      :key="i"
      class="review-star"
      :name="i <= local ? 'STAR' : 'STAR_EMPTY'"
      @click="() => (local = i)"
    />
  </div>
</template>

<script>
import { Range } from "@pdfking/tfunc"
import icon from "@pdfking/workflow/components/icon"
export default {
  components: { icon },
  computed: { range: () => [...Range(2, 10, 2)] },
  data() {
    return {
      local: this.value,
    }
  },
  props: ["name", "value"],
}
</script>

<style lang="css" scoped>
.review-star {
  cursor: pointer;
}
</style>
